import React from 'react';

export const NoDataFound = ({
    heading = 'No Data Found',
    message = 'We couldn’t find any data to display.',
    bg = 'var(--col-floating-bg)',
    styles = {}
}) => {

    const css = {
        container: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '0 20px',
            backgroundColor: bg,
            color: 'var(--col-2D343F)',
            ...styles
        },
        heading: {
            fontSize: '1.5rem',
            marginBottom: '0.5rem',
        },
        message: {
            fontSize: '0.9rem',
        },
    };

    return (
        <div style={css.container}>
            <h1 style={css.heading}>{heading}</h1>
            <p style={css.message}>{message}</p>
        </div>
    );
};

